import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class ReportsService {
  appNodeHostUrl: any = environment.API_BASE_URL;
  urlToScraperHealth = environment.SCRAPER_BASE_URL + 'pdfScraper/getHealthReport';

  constructor(private _http: HttpClient) {}

  getAverageSavings(data: any): Observable<any> {
    data.isAverageDetails = true;
    return this._http
      .post(this.appNodeHostUrl + 'api/savingsReport', data)
      .map((res: Response) => res);
  }

  getAccountLevelSavings(data: any): Observable<any> {
    data.isAccountLevelDetails = true;
    return this._http
      .post(this.appNodeHostUrl + 'api/savingsReport', data)
      .map((res: Response) => res);
  }

  getScraperHealth(data: any): Observable<any> {
    return this._http.get(this.urlToScraperHealth).map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/reports.service.ts